export default function SectionLabel({ children }) {
  return <div className="section-label">{children}</div>
}
